module.exports = __webpack_public_path__ + "img/home-service-qilu.716af7ae.png";